import axios from "axios";
import { toast } from "react-toastify";

export const getGoal = async (goalId, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getGoal/${goalId}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getClubGoal = async (goalId, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/clubs/getGoal/${goalId}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    if (error?.response?.data) {
      toast.error(error?.response?.data);
    } else {
      toast.error(error.message);
    }
    throw new Error(error.message);
  }
};
